import { IApiError } from '@/infra/exceptions/interfaces/api-error';
import { IValidationError } from '@/infra/exceptions/interfaces/validation-error';

export class ApiError extends Error {
  public readonly traceId: string;
  public readonly title: string;
  public readonly status: string;
  public readonly errors: IValidationError[];

  constructor(apiError: IApiError) {
    super(apiError.title);

    this.name = 'ApiError';
    this.traceId = apiError.traceId;
    this.title = apiError.title;
    this.status = apiError.status;
    this.errors = apiError.errors;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
  }
}
